module.exports = {
      id: "expand_more-usage",
      viewBox: "0 0 13 8",
      url: __webpack_public_path__ + "svg-sprite-39ec39c5b3d32c0adb9732979a5c9627.svg#expand_more",
      toString: function () {
        return this.url;
      }
    }